module.exports = __webpack_public_path__ + "static/img/VI.e94dd87b.svg";